import { BetAmountInputProps } from './props';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import BetAmountInputButtons from '../Buttons';
import { useBetAmountInputSetting } from '@/hooks/games/useBetAmountInputSetting';
import { SettingLayoutComponentId } from '@starsoft/common/models';

export default function BetAmountInputSkeleton({
  hasExtraButtons,
}: BetAmountInputProps) {
  const { version } = useBetAmountInputSetting();
  return (
    <div className={styles.container}>
      <div
        className={`${styles['container__input-wrapper']} ${version > SettingLayoutComponentId.BetAmountInputV1?.toString() ? styles['container__input-wrapper--default'] : ''}`}
      >
        <div className={skeleton.input} />
        {hasExtraButtons &&
          version < SettingLayoutComponentId.BetAmountInputV3?.toString() && (
            <BetAmountInputButtons bet={null} isLoading />
          )}
      </div>
      {hasExtraButtons &&
        version > SettingLayoutComponentId.BetAmountInputV2?.toString() && (
          <BetAmountInputButtons bet={null} isLoading />
        )}
    </div>
  );
}
